var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.exercise)?_c('div',[_vm._v("There doesn't seem to be anything here")]):_c('exercise-container',{attrs:{"exercise":_vm.exercise,"one-rep-max":_vm.oneRepMax}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffe3308","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Exercise.vue
// module id = null
// module chunks = 